export const UPDATE_POOL_REQUEST_FAILURE = 'UPDATE_POOL_REQUEST_FAILURE';

export const updatePoolRequestFailure = error => ({
    type: UPDATE_POOL_REQUEST_FAILURE,
    payload: error,
    error: true,
});
